import { render, staticRenderFns } from "./dashboardReportsHr.vue?vue&type=template&id=30b7ad1c&"
import script from "./dashboardReportsHr.vue?vue&type=script&lang=js&"
export * from "./dashboardReportsHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports